import { Link } from 'react-router-dom';
import Logo from './Logo';
import { Phone, Mail, MapPin, ArrowUpRight } from 'lucide-react';import { WA_DEFAULT_LINK, WA_NUMBER_DISPLAY, SUPPORT_EMAIL } from '../lib/lead';
import { WhatsAppGlyph } from './StickyWhatsApp';

const LEGAL_LINKS = [
  { label: 'Privacy Policy', to: '/privacy', testid: 'footer-privacy-link' },
  { label: 'Terms of Service', to: '/terms', testid: 'footer-terms-link' },
  { label: 'Refund Policy', to: '/refund', testid: 'footer-refund-link' },
  { label: 'Legal Disclaimer', to: '/disclaimer', testid: 'footer-disclaimer-link' },
  { label: 'Admin Login', to: '/admin', testid: 'footer-admin-link' },
];

export default function Footer() {
  return (
    <footer className="bg-brand-ink text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 lg:gap-8">
          <div className="md:col-span-5">
            <Logo dark size={42} />
            <p className="mt-5 text-sm leading-relaxed text-white/55 max-w-sm" data-testid="footer-disclaimer-text">
              Settalkar is a specialized legal technology and consultancy service facilitating lawful challan settlement
              and court representation. We adhere to statutory legal processes across India.
            </p>
            <p className="mt-4 text-xs leading-relaxed text-white/35">
              Settalkar is a private service and is not affiliated with any government body, RTO, or court.
            </p>
          </div>

          <div className="md:col-span-3">
            <h3 className="text-xs font-bold uppercase tracking-[0.2em] text-brand-orange">Contact</h3>
            <ul className="mt-5 flex flex-col gap-4">
              <li>
                <a
                  href={WA_DEFAULT_LINK}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-start gap-3 text-sm font-semibold text-white/80 hover:text-brand-orange transition-colors"
                  data-testid="footer-whatsapp-link"
                >
                  <WhatsAppGlyph size={17} />
                  <span>
                    {WA_NUMBER_DISPLAY}
                    <span className="block text-xs font-medium text-white/40">Call / WhatsApp — Pan-India</span>
                  </span>
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${SUPPORT_EMAIL}`}
                  className="flex items-center gap-3 text-sm font-semibold text-white/80 hover:text-brand-orange transition-colors"
                  data-testid="footer-email-link"
                >
                  <Mail size={17} /> {SUPPORT_EMAIL}
                </a>
              </li>
              <li className="flex items-center gap-3 text-sm font-semibold text-white/80">
                <MapPin size={17} /> Serving every state &amp; UT, online
              </li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h3 className="text-xs font-bold uppercase tracking-[0.2em] text-brand-orange">Quick Links</h3>
            <ul className="mt-5 flex flex-col gap-3">
              {LEGAL_LINKS.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="text-sm font-semibold text-white/80 hover:text-brand-orange transition-colors inline-flex items-center gap-1 group"
                    data-testid={l.testid}
                  >
                    {l.label}
                    <ArrowUpRight size={13} className="opacity-0 group-hover:opacity-100 transition-opacity" />
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <h3 className="text-xs font-bold uppercase tracking-[0.2em] text-brand-orange">On This Site</h3>
            <ul className="mt-5 flex flex-col gap-3 text-sm font-semibold text-white/80">
              <li><Link to="/" className="hover:text-brand-orange transition-colors" data-testid="footer-home-link">Home</Link></li>
              <li><Link to="/#how-it-works" className="hover:text-brand-orange transition-colors" data-testid="footer-how-it-works-link">How It Works</Link></li>
              <li><Link to="/#services" className="hover:text-brand-orange transition-colors" data-testid="footer-services-link">Services</Link></li>
              <li><Link to="/#faqs" className="hover:text-brand-orange transition-colors" data-testid="footer-faqs-link">FAQs</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-7 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs font-medium text-white/40">© {new Date().getFullYear()} Settalkar — settalkar.com. All rights reserved.</p>
          <p className="text-xs font-medium text-white/40">Settle legally. Drive freely.</p>
        </div>
      </div>
    </footer>
  );
}
